<div class="sb-offering-card rds-shadow-2">
  <div class="sb-offering-card-header">
    @if (displayName()) {
      <h4 class="ui-heading-4-bold sb-offering-card-title">
        {{ displayName() }}
      </h4>
    }

    @if (badges()) {
      @for (badge of badges(); track badge._uid) {
        <rds-badge
          [size]="badge.size"
          [label]="badge.label"
          [type]="badge.type"
          [color]="badge.color"
        >
        </rds-badge>
      }
    }
  </div>
  <div class="sb-offering-card-content">
    <p
      class="ui-body-l description"
      [matTooltip]="description()"
      matTooltipPosition="above"
      [matTooltipShowDelay]="1000"
    >
      {{ description() }}
    </p>
  </div>
  <div class="sb-offering-card-footer">
    @for (btn of buttons(); track btn._uid) {
      @if (components[btn.component]) {
        <ndc-dynamic
          [ndcDynamicComponent]="components[btn.component]"
          [ndcDynamicInputs]="btn"
        >
        </ndc-dynamic>
      }
    }
  </div>
</div>
